import { useCallback, useEffect, useState } from 'react';
import { getPaymentRail } from '../redux/payment/action';
import type { IPaymentRailResponse } from '../redux/payment/types';
import { useDispatchPromise } from '../utils/AppUtils';

/** Loads GET /payment/rail?category=… — country is server-detected only. */
export function usePaymentRail(category: string, enabled = true) {
    const dispatchPromise = useDispatchPromise();
    const [rail, setRail] = useState<IPaymentRailResponse | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const refresh = useCallback(async () => {
        if (!enabled) return null;
        setLoading(true);
        setError(null);
        try {
            const data = (await dispatchPromise(getPaymentRail({ category }))) as IPaymentRailResponse;
            setRail(data);
            return data;
        } catch (err: unknown) {
            const msg =
                (err as { data?: { message?: string } })?.data?.message ??
                (err as Error)?.message ??
                'Could not detect payment region';
            setError(msg);
            return null;
        } finally {
            setLoading(false);
        }
    }, [category, dispatchPromise, enabled]);

    useEffect(() => {
        void refresh();
    }, [refresh]);

    return { rail, loading, error, refresh };
}
